export const CHECK_AUTH = 'checkAuth';
export const LOGIN = 'login';
export const ADMIN_LOGIN = 'admin_login';
export const ADMINLOGOUT = 'admin-logout';
export const LOGOUT = 'logout';
export const SET_PROFILE_DATA = 'set_profile_data';
export const ADMIN = 'admin';
export const WEBSITE = 'website';

export const GET_API = 'get_api';
export const POST_API = 'post_api';
export const PUT_API = 'put_api';
export const DELETE_API = 'delete_api';
export const UPDATE_AUTH_PUT_API = 'update_auth_put_api';
export const UPDATE_AUTH_POST_API = 'update_auth_post_api';

export const GET_DEPOSIT_DATA = 'get_deposit_data';
export const SAVE_DEPOSIT_DATA = 'save_deposit_data';
export const UPDATE_DEPOSIT_DATA = 'update_deposit_data';
export const DELETE_DEPOSIT_DATA = 'delete_deposit_data';
export const GET_SAVING_ACCOUNT_FORM_DATA = 'get_saving_account_form_data';
export const GET_EDIT_SAVING_ACCOUNT_FORM_DATA = 'get_edit_saving_account_form_data';
export const GET_FIXED_DEPOSIT_FORM_DATA = 'get_fixed_deposit_form_data';
export const GET_EDIT_FIXED_DEPOSIT_FORM_DATA = 'get_edit_fixed_deposit_form_data';
export const GET_RECCURING_DEPOSIT_FORM_DATA = 'get_reccuring_deposit_form_data';
export const GET_EDIT_RECCURING_DEPOSIT_FORM_DATA = 'get_edit_reccuring_deposit_form_data';
export const GET_SUKANAYA_SAMARIDDHI_FORM_DATA = 'get_sukanya_samariddhi_form_data';
export const GET_EDIT_SUKANAYA_SAMARIDDHI_FORM_DATA = 'get_edit_sukanya_samariddhi_form_data';
export const GET_CATEGORY_DATA = 'get_category_data';
export const GET_SUB_CATEGORY_DATA = 'get_sub_category_data';
export const CHECK_FORM_DATA_EXISTS = 'check_form_data_exists';

export const GET_MUTUAL_FUND_DATA = 'get_mutual_fund_data';
export const GET_LUMPSUM_INVESTMENT_FORM_DATA = 'get_lumpsum_investment_form_data';
export const GET_SCHEME_NAME_DATA = 'get_scheme_name_data';
export const GET_SCHEME_NAME_DETAIL = 'get_scheme_name_detail';
export const DELETE_MUTUALFUND_DATA = 'delete_mutual_fund_data';
export const SAVE_MUTUALFUND_DATA = 'save_mutual_fund_data';
export const GET_LUMPSUM_INVESTMENT_EDIT_FORM_DATA = 'get_lumpsum_investment_edit_form_data';
export const GET_SYSTEMATIC_INVESTMENT_PLAN_FORM_DATA = 'get_systematic_investment_plan_form_data';
export const GET_EDIT_SYSTEMATIC_INVESTMENT_FORM_DATA = 'get_edit_systematic_investment_form_data';
export const GET_MUTUAL_FUND_GRAPH_DATA = 'get_mutual_fund_graph_data';

export const GET_BULLIONS_DATA = 'get_bulliuons_data';
export const DELETE_BULLIONS_DATA = 'delete_bulliuons_data';
export const GET_BARS_COIN_FORM_DATA = 'get_bars_coin_form_data';
export const GET_BULLION_TYPE_DATA = 'get_bullion_type_data';
export const GET_PRICE_OF_PURITY = 'get_price_of_purity';
export const SAVE_BULLIONS_DATA = 'save_bullions_data';
export const GET_EDIT_BARS_COIN_FORM_DATA = 'get_edit_bars_coin_form_data';
export const GET_JEWELLERY_ADD_FORM_DATA = 'get_jewellery_add_form_data';
export const GET_JEWELLERY_EDIT_FORM_DATA = 'get_jewellery_edit_form_data';
export const GET_ADD_DIGITAL_GOLD_ADD_FORM_DATA = 'get_digital_gold_add_form_data';
export const GET_EDIT_DIGITAL_GOLD_FORM_DATA = 'get_edit_digital_gold_add_form_data';
export const GET_SOVEREIGN_GOLD_BONDS_ADD_DATA = 'get_sovereign_gold_bonds_add_data';
export const GET_GOLD_BOND_DATA = 'get_gold_bond_data';
export const GET_SOVEREIGN_GOLD_BONDS_EDIT_DATA = 'get_sovereign_gold_bonds_edit_data';

export const GET_EQUITIES_AND_BOND_DATA = 'get_equities_and_bond_data';
export const DELETE_EQUITIES_AND_BOND_DATA = 'delete_equities_and_bond_data';
export const GET_EQUITIES_ADD_FORM_DATA = 'get_equities_add_form_data';
export const SAVE_EQUITIES_BOND_FORM = 'save_equities_bond_form';
export const GET_SECURITY_LIST = 'get_security_list';
export const GET_SECURITY_NAME = 'get_security_name';
export const GET_SERIES_LIST = 'get_series_list';
export const GET_SERIES_DETAIL = 'get_series_detail';
export const GET_EQUITY_EDIT_FORM_DETAIL = 'get_equity_edit_form_detail';
export const UPDATE_EQUITY_BOND_FORM_DETAIL = 'update_equity_bond_form_detail';

export const REGISTRATION_DATA 	= 'registration_data';
export const VERIFY_EMAIL_OTP 	= 'verify_email_otp';
export const VERIFY_MOBILE_OTP	= 'verify_mobile_otp';
export const USER_SIGNIN = 'user_signin';
export const GET_PROFILE_DETAIL	= 'get_profile_detail';
export const UPDATE_PROFILE_DETAIL	= 'update_profile_detail';
export const GET_REFERRAL_DETAIL = 'get_referral_detail';
export const CREATE_DEFAULT_SUBSCRIPTION = 'create_default_subscription';
export const GET_USER_PLAN_DETAIL = 'get_user_plan_detail';
export const CREATE_USER_PLAN_SUBSCRIPTION = 'create_user_plan_subscription';
export const VERIFY_RAZORPAY_SIGNATURE = 'verify_razoepay_signature';
export const USER_SIGNOUT = 'user_signout';
export const USER_DETAILS = 'user_details';
export const UPDATE_USER_DETAILS = 'update_user_details';

export const CANCEL_SUBSCRIPTION = 'cancel_subscription';
export const GET_FAMILY_MEMBER_LIST = 'get_family_member_list';
export const DELETE_FAMILY_MEMBER = 'delete_family_member';
export const GET_FAMILY_MEMBER_DETAIL = 'get_family_member_detail';
export const UPDATE_FAMILY_MEMBER_DETAIL = 'update_family_member_detail';
export const GET_USER_PROFILE_DETAIL = 'get_user_profile_detail';
export const SAVE_FAMILY_MEMBER_DETAIL = 'save_family_member_detail';
export const UPDATE_USER_PROFILE_DETAIL = 'update_user_profile_detail';
export const CHANGE_PASSWORD = 'change_password';
export const GET_PLAN_DETAIL = 'get_plan_detail';
export const GET_NOTIFICATION_LIST = 'get_notification_list';
export const DELETE_NOTIFICATION_DATA = 'delete_notification_data';

export const GET_LIABILITY_FORM = 'get_liability_form';
export const SAVE_LIABILITY_FORM_DETAIL = 'save_liability_form_detail';
export const GET_LIABILITY_FORM_DETAIL = 'get_liability_form_detail';
export const GET_EDIT_LIABILITY_FORM_DETAIL = 'get_edit_liability_form_detail';
export const UPDATE_LIABILITY_FORM = 'update_liability_form';
export const DELETE_LIABILITY_FORM = 'delete_liability_form';
export const GET_STUDENT_FORM = 'get_student_form';
export const GET_PERSONAL_FORM = 'get_personal_form';
export const GET_CAR_FORM = 'get_car_form';
export const GET_POLICY_FORM = 'get_policy_form';
export const GET_CONSUMER_FORM = 'get_consumer_form';
export const GET_LOANAGAINST_FORM = 'get_loanagainst_form';
export const GET_TWOWHEELER_FORM = 'get_twowheeler_form';
export const GET_CREDIT_CARD_FORM = 'get_credit_card_form';
export const GET_OVER_DRAFT_FORM = 'get_over_draft_form';

export const GET_INVESTOMETER_DETAIL = 'get_investometer_detail';

export const GET_COMMODITY_FORM = 'get_commodity_form';
export const GET_COMMODITY_FORM_DETAIL = 'get_commodity_form_detail';
export const SAVE_COMMODITY_FORM_DETAIL = 'save_commodity_form_detail';
export const GET_COMMODITY_LOCATION_LIST = 'get_commodity_location_list';
export const GET_COMMODITY_PRICE_LIST = 'get_commodity_price_list';
export const GET_COMMODITY_LIST = 'get_commodity_list';
export const DELETE_FORM = 'delete_form';
export const GET_EDIT_COMMODITY_FORM_DETAIL = 'get_edit_commodity_form_detail';
export const UPDATE_COMMODITY_FORM = 'update_commodity_form';

export const GET_RETIREMENT_FORM_DETAIL = 'get_retirement_form_detail';
export const GET_PPF_FORM = 'get_ppf_form';
export const GET_EPF_FORM = 'get_epf_form';
export const GET_NPS_FORM = 'get_nps_form';
export const GET_AS_FORM = 'get_as_form';
export const GET_MIS_FORM = 'get_mis_form';
export const SAVE_RETIREMENT_FORM_DETAIL = 'save_retirement_form_detail';
export const EDIT_RETIREMENT_FORM = 'edit_retirement_form';
export const UPDATE_RETIREMENT_FORM = 'update_retirement_form';
export const GET_POLICY_NAME = 'get_policy_name';


export const GET_INSURANCE_FORM_DETAIL = 'get_insurance_form_detail';
export const SAVE_INSURANCE_FORM_DETAIL = 'save_insurance_form_detail';
export const EDIT_INSURANCE_FORM = 'edit_insurance_form';
export const UPDATE_INSURANCE_FORM = 'update_insurance_form';
export const GET_LIFE_FORM = 'get_life_form';
export const GET_HEALTH_FORM = 'get_health_form';
export const GET_PROPERTY_FORM = 'get_property_form';
export const GET_GROUP_FORM = 'get_group_form';
export const GET_VEHICLE_FORM = 'get_vehicle_form';
export const GET_TRAVEL_FORM = 'get_travel_form';
export const GET_ACCIDENTAL_FORM = 'get_accidental_form';
export const GET_POLICY_NAME_DATA = 'get_policy_name_data';



export const GET_REAL_ESTATE_FORM_DETAIL = 'get_real_state_form_detail';
export const DELETE_REAL_ESTATE_FORM = 'delete_real_state_form';
export const SAVE_REAL_ESTATE_FORM_DETAIL = 'save_real_state_form_detail';
export const GET_REAL_ESTATE_FORM = 'get_real_state_form';
export const GET_CITY = 'get_city';
export const GET_LOCATION_LIST = 'get_location_list';
export const GET_EDIT_REAL_ESTATE_FORM = 'get_edit_real_estate_form';
export const UPDATE_REAL_ESTATE_FORM = 'update_real_estate_form';
export const GET_COMMERCIAL_FORM = 'get_commercial_form';
export const GET_INDUSTRIAL_FORM = 'get_industrial_form';
export const GET_LAND_FORM = 'get_land_form';
export const GET_REIT_FORM = 'get_reit_form';
export const GET_IIT_FORM = 'get_iit_form';
export const GET_INVESTMENT_TRUST_TYPE = 'get_investment_trust_type';
export const GET_INVESTMENT_TRUST_PRICE = 'get_investment_trust_price';
export const GET_LOCATION_PRICE = 'get_location_price';

export const GET_EMPLOYEE_FORM = 'get_employee_form';
export const GET_PORTFOLIO_FORM = 'get_portfolio_form';
export const GET_ALTERNATE_FORM = 'get_alternate_form';
export const SAVE_PRIVATE_INVESTMENT_DETAIL = 'save_private_investment_detail';
export const GET_PRIVATE_INVESTMENT_FORM_DETAIL = 'get_private_investment_form_detail';
export const GET_EDIT_PRIVATE_INVESTMENT_FORM = 'get_edit_private_investment_form';
export const UPDATE_PRIVATE_INVESTMENT_FORM = 'update_private_investment_form';
export const GET_PMS_NAME = 'get_pms_name';

export const GET_DEMAT_FORM = 'get_demat_form';
export const GET_TRADING_FORM = 'get_trading_form';
export const GET_EINSURANCE_FORM = 'get_einsurance_form';
export const SAVE_ACCOUNTS_FORM_DETAIL = 'save_account_detail';
export const GET_ACCOUNTS_FORM_DETAIL = 'get_account_form_detail';
export const GET_EDIT_ACCOUNTS_FORM = 'get_edit_accounts_form';
export const UPDATE_ACCOUNTS_FORM = 'update_accounts_form';
export const DELETE_ACCOUNT_FORM = 'delete_account_form';
export const GET_DP_NAME_DATA = 'get_dp_name_form';

export const GET_KEEP_SAFE_CATEGORY_DATA = 'get_keep_safe_category_data';
export const GET_KEEP_SUB_SAFE_CATEGORY_DATA = 'get_keep_safe_sub_category_data';  
export const GET_DEPOSIT_KEEP_SAFE_DATA = 'get_deposit_keep_safe_data';
export const GET_LAST_CHOOSEN_KEEP_SAFE_FORM_DATA = 'get_last_choosen_keep_safe_form_data';
export const SAVE_DEPOSIT_KEEP_SAFE_DATA = 'save_deposit_keep_safe_data';

export const GET_MUTUAL_FUND_KEEP_SAFE_DATA = 'get_mutual_fund_keep_safe_data';
export const SAVE_MUTUAL_FUND_KEEP_SAFE_DATA = 'save_mutual_fund_keep_safe_data';

export const GET_REAL_ESTATE_KEEP_SAFE_DATA = 'get_real_estate_keep_safe_data';
export const SAVE_REAL_ESTATE_KEEP_SAFE_DATA = 'save_real_estate_keep_safe_data';

export const GET_EQUITY_BOND_KEEP_SAFE_DATA = 'get_equity_bond_keep_safe_data';
export const SAVE_EQUITY_BOND_KEEP_SAFE_DATA = 'save_equity_bond_keep_safe_data';

export const GET_COMMODITY_KEEP_SAFE_DATA = 'get_commodity_keep_safe_data';
export const SAVE_COMMODITY_KEEP_SAFE_DATA = 'save_commodity_keep_safe_data';

export const GET_INSURANCE_KEEP_SAFE_DATA = 'get_insurance_keep_safe_data';
export const SAVE_INSURANCE_KEEP_SAFE_DATA = 'save_insurance_keep_safe_data';

export const GET_RETIREMENT_KEEP_SAFE_DATA = 'get_retirement_keep_safe_data';
export const SAVE_RETIREMENT_KEEP_SAFE_DATA = 'save_retirement_keep_safe_data';

export const GET_BULLIONS_KEEP_SAFE_DATA = 'get_bullions_keep_safe_data';
export const SAVE_BULLIONS_KEEP_SAFE_DATA = 'save_bullions_keep_safe_data';

export const GET_PRIVATE_INVESTMENT_KEEP_SAFE_DATA = 'get_private_investment_keep_safe_data';
export const SAVE_PRIVATE_INVESTMENT_KEEP_SAFE_DATA = 'save_private_investment_keep_safe_data';

export const GET_TAX_FILLING_KEEP_SAFE_DATA = 'get_tax_filling_keep_safe_data';
export const SAVE_TAX_FILLING_KEEP_SAFE_DATA = 'save_tax_filling_keep_safe_data';
export const CREATE_PAYMENT_LINK = 'create_payment_link';
export const GET_PAYMENT_INFO  = 'get_payment_info';

export const SEND_MOBILE_OTP = 'send-otp-delete-account';